/** @format */

import { useContext } from 'react';
import { BusinessDispatcherContext } from 'providers';

function useBusinessDispatcher() {
  return useContext(BusinessDispatcherContext);
}

export { useBusinessDispatcher };
